const oktaInternalAuthConfig = {
  baseUrl: `https://${process.env.REACT_APP_OKTA_DOMAIN}`,
  issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN}`,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
  authParams: {
    issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN}`,
  },
};

const oktaExternalAuthConfig = {
  baseUrl: `https://${process.env.REACT_APP_OKTA_DOMAIN_EXTERNAL}`,
  issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN_EXTERNAL}`,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID_EXTERNAL,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
  authParams: {
    issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN_EXTERNAL}`,
  },
};

export { oktaInternalAuthConfig, oktaExternalAuthConfig };
